import { ref, watch } from 'vue'
import { loadFromStorage, booleanFormatter, numberFormatter } from '@/utils'

export const useCexCexTwoLegsSettings = () => {
  const autoPrepare = ref(false)
  const orderNotifications = ref(true)
  const useMarketOrder = ref(false)
  const closeOnFail = ref(false)
  const reduceOnly = ref(false)
  const triggerConfirmations = ref(false)
  const maxSignalsCounter = ref(3)

  reduceOnly.value = loadFromStorage<boolean>('reduce-only', booleanFormatter, false)
  autoPrepare.value = loadFromStorage<boolean>('auto-prepare', booleanFormatter, true)
  orderNotifications.value = loadFromStorage<boolean>('order-motifications', booleanFormatter, true)
  useMarketOrder.value = loadFromStorage<boolean>('use-market-order', booleanFormatter, false)
  closeOnFail.value = loadFromStorage<boolean>('close-on-fail', booleanFormatter, false)
  triggerConfirmations.value = loadFromStorage<boolean>(
    'triggerConfirmations',
    booleanFormatter,
    false,
  )
  maxSignalsCounter.value = loadFromStorage<number>('max-signals-counter', numberFormatter, 3)

  watch(reduceOnly, (v) => {
    localStorage.setItem('reduce-only', v ? '1' : '0')
  })

  watch(autoPrepare, (v) => {
    localStorage.setItem('auto-prepare', v ? '1' : '0')
  })

  watch(orderNotifications, (v) => {
    localStorage.setItem('order-motifications', v ? '1' : '0')
  })

  watch(useMarketOrder, (v) => {
    localStorage.setItem('use-market-order', v ? '1' : '0')
  })

  watch(closeOnFail, (v) => {
    localStorage.setItem('close-on-fail', v ? '1' : '0')
  })

  watch(triggerConfirmations, (v) => {
    localStorage.setItem('triggerConfirmations', v ? '1' : '0')
  })

  watch(maxSignalsCounter, (v) => {
    localStorage.setItem('max-signals-counter', v.toString())
  })

  return {
    autoPrepare,
    orderNotifications,
    useMarketOrder,
    closeOnFail,
    reduceOnly,
    triggerConfirmations,
    maxSignalsCounter,
  }
}
